module.exports = __webpack_public_path__ + "img/product_mb_vn_th_my_sg_ph.4e74a58.webp";